import { render } from "./HomeDown.vue?vue&type=template&id=6573f230&scoped=true"
import script from "./HomeDown.vue?vue&type=script&lang=js"
export * from "./HomeDown.vue?vue&type=script&lang=js"

import "./HomeDown.vue?vue&type=style&index=0&id=6573f230&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6573f230"]])

export default __exports__